module.exports = __webpack_public_path__ + "static/2017-aeta-outreach6-76ec7da33502d5ea9cac49da6e9d5594.jpg";